import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc,
} from 'firebase/firestore';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        const notifRef = collection(db, 'notifications');
        const q = query(notifRef, where('userEmail', '==', currentUser.email));

        const unsubscribeSnapshot = onSnapshot(q, (snapshot) => {
          const notifData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setNotifications(notifData);

          // Mark unread notifications as read
          notifData.forEach((n) => {
            if (!n.read) {
              updateDoc(doc(db, 'notifications', n.id), { read: true });
            }
          });
        });

        return () => unsubscribeSnapshot();
      }
    });

    return () => unsubscribeAuth();
  }, []);

  return (
    <div style={{
      padding: '2rem',
      maxWidth: '800px',
      margin: 'auto',
      fontFamily: 'Arial, sans-serif',
    }}>
      <h2 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
        🔔 Your Notifications
      </h2>

      {notifications.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#888' }}>
          No new notifications at the moment.
        </p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {notifications.map((notification) => (
            <li
              key={notification.id}
              style={{
                backgroundColor: notification.read ? '#f9f9f9' : '#e0f7fa',
                borderLeft: '5px solid #007bff',
                padding: '1rem',
                marginBottom: '1rem',
                borderRadius: '6px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              }}
            >
              <p style={{ marginBottom: '0.5rem' }}>
                {notification.message}
              </p>
              <small style={{ color: '#666' }}>
                {new Date(notification.timestamp?.seconds * 1000).toLocaleString()}
              </small>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notifications;
